import React from 'react';

import { SectionDynaimcShelfProps } from './types/SectionArticleShelves.types';
import { white, gallery } from './styles/SectionShelf.styles';
import CardCarousel from '@legacy-vfuk/core-card-carousel';
import { ArticleCard } from '../../Elements/ArticleCard';
import {
  CarouselWrapper,
  DynaimcShelfHeading,
  MobileShelfWrapper,
  SeeAllButton,
  ShelfArticleWrapper,
} from './styles/SectionDynamicShelf.styles';
import Icon from '@legacy-vfuk/core-icon';

const SectionDynamicShelf = ({
  direction,
  id,
  displayName,
  type,
  seeAllLabel,
  displaySeeAllLabel,
  articles,
  backgroundColor,
  readingTimeMinuteLabel,
  displaySaveIcon,
  saveLabelText,
  seoTitle,
  articleIndexSlug,
  slidesToShow,
  subtopicSlug,
  handleSaveClick,
  handleSeeAllClick,
}: SectionDynaimcShelfProps) => {
  const backgroundStyle = backgroundColor === 'white' ? white : gallery;

  const cardsToShow = slidesToShow ? slidesToShow : 3;

  const theArticles = articles.map(article => {
    return (
      <ShelfArticleWrapper className="page-article-container" key={article.id}>
        <ArticleCard
          isAnimated={true}
          isMedia={type === 'media' ? true : false}
          isFeatured={false}
          key={article.id}
          indexSlug={articleIndexSlug}
          data={article}
          backgroundColor={'gallery'}
          seoTitle={seoTitle}
          readingTimeMinuteLabel={readingTimeMinuteLabel}
          displaySaveIcon={displaySaveIcon}
          saveLabelText={saveLabelText}
          handleSaveClick={handleSaveClick}
        />
      </ShelfArticleWrapper>
    );
  });

  return (
    <div css={backgroundStyle}>
      <div className="spring custom-spring">
        <DynaimcShelfHeading>
          <h3>{displayName}</h3>

          {displaySeeAllLabel && (
            <SeeAllButton
              onClick={() => {
                type === 'subtopic'
                  ? handleSeeAllClick(type, subtopicSlug)
                  : handleSeeAllClick(type);
              }}
            >
              <p>{seeAllLabel}</p>
              <Icon
                name={direction === 'rtl' ? 'chevron-left' : 'chevron-right'}
                appearance="secondary"
                size={1}
              />
            </SeeAllButton>
          )}
        </DynaimcShelfHeading>
        <MobileShelfWrapper>{theArticles}</MobileShelfWrapper>
        <CarouselWrapper direction={direction}>
          <CardCarousel
            srName="carousel-article"
            slidesToShow={{ xl: cardsToShow }}
            slidesToScroll={{ xl: 1, lg: 1, md: 1, sm: 1 }}
            id={id}
          >
            {theArticles}
          </CardCarousel>
        </CarouselWrapper>
      </div>
    </div>
  );
};

export default SectionDynamicShelf;
